import { render, staticRenderFns } from "./ProjectPrefundRevisionTab.vue?vue&type=template&id=03a75a38&"
import script from "./ProjectPrefundRevisionTab.vue?vue&type=script&lang=js&"
export * from "./ProjectPrefundRevisionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports